import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../config";
import { useLang } from "../i18n";
import { CheckCircle2, Loader2, Clock } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("unknown");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  const content = {
    checking: { icon: <Loader2 className="w-14 h-14 text-topacio-red animate-spin" />, title: t.pay.checking, sub: "" },
    paid: { icon: <CheckCircle2 className="w-14 h-14 text-topacio-green" />, title: t.pay.success, sub: t.pay.successSub },
    pending: { icon: <Clock className="w-14 h-14 text-topacio-red" />, title: t.pay.pending, sub: t.pay.pendingSub },
    unknown: { icon: <Clock className="w-14 h-14 text-topacio-red" />, title: t.pay.pending, sub: t.pay.pendingSub },
  }[status];

  return (
    <div className="min-h-screen bg-topacio-sand flex flex-col items-center justify-center px-6 py-10" data-testid="payment-success-page">
      <div className="text-center max-w-md card-brutal p-10">
        <div className="flex justify-center">{content.icon}</div>
        <h1 className="font-display font-bold text-topacio-ink text-2xl mt-6">{content.title}</h1>
        {content.sub && <p className="text-topacio-faded mt-3">{content.sub}</p>}
        <Link to="/" data-testid="payment-home-btn" className="btn-primary mt-8">{t.pay.home}</Link>
      </div>
      <SiempriaCredit />
    </div>
  );
}
